import { render, staticRenderFns } from "./single-stat-icon.vue?vue&type=template&id=4a2fca99&"
import script from "./single-stat-icon.vue?vue&type=script&lang=js&"
export * from "./single-stat-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports